// extracted by mini-css-extract-plugin
export default {"security-info-items":"style_security-info-items__Viiw3"};